import CreatePayrollConfig from './views/CreatePayrollConfig.vue'
import ListPayrollsConfig from './views/ListPayrollsConfig.vue'
import PayrollConfigDetail from './views/PayrollConfigDetail.vue'
import HomeLayout from '@/layouts/Home.vue'

export const payrollsConfigRoutes = [
  {
    path: '/payrollsConfig',
    name: 'payrollsConfig',
    component: ListPayrollsConfig,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/add',
    name: 'payrollsConfig/add',
    component: CreatePayrollConfig,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id',
    name: 'payrollsConfig/detail',
    component: PayrollConfigDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
